var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54745 4H4.0292V6.5C4.0292 6.63261 3.97613 6.75979 3.88168 6.85355C3.78723 6.94732 3.65912 7 3.52555 7C3.39197 7 3.26387 6.94732 3.16941 6.85355C3.07496 6.75979 3.0219 6.63261 3.0219 6.5V4H0.50365C0.370073 4 0.241968 3.94732 0.147516 3.85355C0.053063 3.75979 0 3.63261 0 3.5C0 3.36739 0.053063 3.24022 0.147516 3.14645C0.241968 3.05268 0.370073 3 0.50365 3H3.0219V0.5C3.0219 0.367392 3.07496 0.240215 3.16941 0.146446C3.26387 0.0526783 3.39197 0 3.52555 0C3.65912 0 3.78723 0.0526783 3.88168 0.146446C3.97613 0.240215 4.0292 0.367392 4.0292 0.5V3H6.54745C6.68102 3 6.80913 3.05268 6.90358 3.14645C6.99803 3.24022 7.0511 3.36739 7.0511 3.5C7.0511 3.63261 6.99803 3.75979 6.90358 3.85355C6.80913 3.94732 6.68102 4 6.54745 4Z",
    fill: "#2898A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2ab762081d286c10a059cccf52198494.svg";
export { ForwardRef as ReactComponent };